import { Container, Col, Row } from 'react-bootstrap'
import './Projects.css'
import { useAppSelector } from '../../../app/hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartShopping, faCheck, faEarth } from '@fortawesome/free-solid-svg-icons';

const Projects = () => {
    const resize = useAppSelector((state) => state.navbar.resize)
    return (
        <Container className='projects-wrapper' fluid style={{
            marginLeft: resize ? '0' : '20rem',
            width: resize ? '' : 'calc(100vw - 20rem)',
            backgroundColor: 'rgb(8, 13, 19)',
            height: '100vh',
            paddingBottom: '10rem',
            paddingRight: '0',
            paddingLeft: '0',
          }}>
            <Row className='flex-lg-row' lg={12}>
                <Row className='row'>
                    <Col className='d-flex w-100'>
                        <div className='title fs-4 text-success text-start m-4 p-4 border border-light rounded w-100'>
                            <Row>
                                <h1 className='text-light fs-2'>Current</h1>
                            </Row>
                        </div>
                    </Col>
                </Row>
                <Row className='row'>
                    <Col className='d-flex w-100'>
                        <div className='title fs-4 text-success text-start m-4 p-4 border border-light rounded w-100'>
                            <Row>
                            <div className='p-1 pt-0 mb-2 text-light'>ShopWise <FontAwesomeIcon icon={faCartShopping} /></div>
                            <div className='code-container border rounded'>
                                <div className="code fw-bold">
                                    Project Information:
                                </div>
                                <div className="code mb-2 p-2 bg-black rounded border-2 text-success">
                                    ShopWise is a mobile application that allows users to create shopping lists and share them with friends and family. The application is built using React Native and Expo Go.
                                </div>
                                <div className="code fw-bold">
                                    Project type:
                                </div>
                                    <div className="code p-2 bg-black rounded border-2 text-success">
                                        <ul>
                                            <li>Mobile App</li>
                                            <li>
                                                <a className='text-decoration-none text-success' href="https://github.com/FFsDeagle/1Trip" target="_blank" rel="noreferrer">
                                                    App
                                                </a>
                                            </li>
                                            <li>
                                                <a className='text-decoration-none text-success' href="https://github.com/FFsDeagle/1TripServer" target="_blank" rel="noreferrer">
                                                    Server
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="code fw-bold">
                                        Tech Stack
                                    </div>
                                    <div className="code">
                                        Front-End
                                    </div>
                                    <div className="code mb-2 p-2 bg-black rounded border-2 text-success">
                                        <ul>
                                            <li>React Native - Expo Go</li>
                                            <li>TypeScript</li>
                                            <li>Redux Toolkit</li>
                                        </ul>
                                    </div>
                                    <div className="code">
                                        Back-End
                                    </div>
                                    <div className="code mb-2 p-2 bg-black rounded border-2 text-success">
                                        <ul>
                                            <li>NodeJs</li>
                                            <li>MongoDB</li>
                                            <li>Mongoose</li>
                                        </ul>
                                    </div>
                                </div>
                            </Row>
                        </div>
                    </Col>
                </Row>
                <Row className='row'>
                    <Col className='d-flex w-100'>
                        <div className='title fs-4 text-success text-start m-4 p-4 border border-light rounded w-100'>
                            <Row>
                                <h1 className='text-light fs-2'>Completed <FontAwesomeIcon icon={faCheck} /></h1>
                            </Row>
                        </div>
                    </Col>
                </Row>
                <Row className='row'>
                    <Col className='d-flex w-100'>
                        <div className='title fs-4 text-success text-start m-4 p-4 border border-light rounded w-100'>
                            <Row>
                            <div className='p-1 pt-0 mb-2 text-light'>KWF (Kaleidoscope World of Fashion) <FontAwesomeIcon icon={faEarth} /></div>
                            <div className='code-container border rounded'>
                                <div className="code fw-bold">
                                    Project type:
                                </div>
                                <div className="code">
                                    <a className='text-decoration-none text-success' href="www.kwf.events" target="_blank" rel="noreferrer">
                                        Website
                                    </a>
                                    <div className='code fw-bold mt-2 mb-2'>
                                        Project information
                                    </div>
                                    <div className='code p-2 bg-black rounded border-2 text-success'>
                                        Client required a website to showcase their fashion events. The website was built using React and Redux Toolkit.
                                    </div>
                                </div>
                                </div>
                            </Row>
                        </div>
                    </Col>
                </Row>
            </Row>
        </Container>
    )
};

export default Projects;
